import { lazy, Suspense } from 'react';

import { Routes, Route, Navigate } from 'react-router-dom';

// import Dashboard from './pages/Dashboard';
const Dashboard = lazy(() => import('./pages/Dashboard'));

const LoginPage = lazy(() => import('./pages/LoginPage'));

const PlaceOrderPage = lazy(() => import('./pages/PlaceOrderPage'));

const TradeHistoryPage = lazy(() => import('./pages/TradeHistoryPage'));

const SecurityListPage = lazy(() => import('./pages/SecurityListPage'));

const SecurityPage = lazy(() => import('./pages/SecurityPage'));

const TestDatePage = lazy(() => import('./pages/TestDatePage'));

const WatchlistPage = lazy(() => import('./pages/WatchlistPage'));

const StrategyActivityPage = lazy(() => import('./pages/StrategyActivityPage'));

const StrategyPage = lazy(() => import('./pages/StrategySettingsPage'));

const GefsPage = lazy(() => import('./pages/GefsPage'));

export const getRoutes = (authorized: boolean) => {
  if (!authorized) {
    return (
      <Suspense fallback={<div> Loading...</div>}>
        <Routes>
          <Route path="/login" element={<LoginPage />}></Route>
          <Route path="*" element={<Navigate to="login" replace />} />
        </Routes>
      </Suspense>
    );
  }
  return (
    <Suspense fallback={<div> Loading...</div>}>
      <Routes>
        <Route path="/" element={<Dashboard />}></Route>
        <Route path="/securities" element={<SecurityListPage />}></Route>
        <Route path="/security/:symbol" element={<SecurityPage />}></Route>
        <Route path="/watchlist" element={<WatchlistPage />}></Route>
        <Route path="/history" element={<TradeHistoryPage />}></Route>
        <Route path="/strategy/:id" element={<StrategyPage />}></Route>
        <Route path="/strategy-activity/:id" element={<StrategyActivityPage />}></Route>
        <Route path="/place-order/:legId" element={<PlaceOrderPage />}></Route>
        <Route path="/test-date" element={<TestDatePage />}></Route>
        <Route path="/gefs" element={<GefsPage />}></Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};
